import { makeStyles } from 'tss-react/mui';

const useStylesDragHandle: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  dragHandleIcon: {
    verticalAlign: 'middle',
    marginRight: 12,
    marginTop: -3,
  },
}));

export default useStylesDragHandle;
